import { toast } from "react-toastify";
import { CustomToast } from "../components/Reusable/CustomToast";
import { t } from "i18next";

export const handleError = (err) => {
  const status = err?.response?.status;

  // ⛔️ Za 401 intentionally ne prikazujemo toast (npr. anonymous session checks).
  if (status === 401) {
    return;
  }

  const errorMessage =
    err?.response?.data?.name ||
    err?.response?.data?.message ||
    err?.message ||
    (typeof err === "string" ? err : t("error.genericError"));

  toast(
    <CustomToast type="error" title={t("error.error")} message={errorMessage} />
  );
};
